import { ModuleColumnDefinition } from '../module'
import { ModuleTypeEnum } from '../module-type'
import { TASK_STANDARD_COLUMNS } from '../task-columns'
import { CONTACT_STANDARD_COLUMNS } from './contact-columns'
import { CONTRACT_STANDARD_COLUMNS } from './contract-columns'
import { CUSTOM_COLLECTION_ENTRY_STANDARD_COLUMNS } from './custom-collection-columns'
import { DEAL_STANDARD_COLUMNS } from './deal-columns'
import { DEPLOYMENT_STANDARD_COLUMNS } from './deployment-columns'
import { DOCUMENT_STANDARD_COLUMNS } from './document-columns'
import { ENTITY_STANDARD_COLUMNS } from './entity-columns'
import { EVENT_STANDARD_COLUMNS } from './event-columns'
import { EXPENSE_STANDARD_COLUMNS } from './expense-columns'
import { INVENTORY_ITEM_STANDARD_COLUMNS } from './inventory-columns'
import { INVOICE_STANDARD_COLUMNS } from './invoice-columns'
import { MEMBER_STANDARD_COLUMNS } from './member-columns'
import { PROJECT_STANDARD_COLUMNS } from './project-columns'
import { QUOTE_STANDARD_COLUMNS } from './quote-columns'
import { SUPPLIER_STANDARD_COLUMNS } from './supplier-columns'
import { TICKET_STANDARD_COLUMNS } from './ticket-columns'
import { TIME_ENTRY_STANDARD_COLUMNS } from './time-entry-columns'

/**
 * Default standard columns per module (without org terminology overrides).
 * Lets non-UI consumers — the API's calculated-field validation, MCP tools —
 * resolve a module's standard fields the same way the web app does.
 */
export const STANDARD_COLUMNS_BY_MODULE: Partial<
  Record<ModuleTypeEnum, ModuleColumnDefinition[]>
> = {
  [ModuleTypeEnum.ENTITY]: ENTITY_STANDARD_COLUMNS,
  [ModuleTypeEnum.PROJECT]: PROJECT_STANDARD_COLUMNS,
  [ModuleTypeEnum.TASK]: TASK_STANDARD_COLUMNS,
  [ModuleTypeEnum.DEAL]: DEAL_STANDARD_COLUMNS,
  [ModuleTypeEnum.CONTACT]: CONTACT_STANDARD_COLUMNS,
  [ModuleTypeEnum.INVOICE]: INVOICE_STANDARD_COLUMNS,
  [ModuleTypeEnum.QUOTE]: QUOTE_STANDARD_COLUMNS,
  [ModuleTypeEnum.CONTRACT]: CONTRACT_STANDARD_COLUMNS,
  [ModuleTypeEnum.TICKET]: TICKET_STANDARD_COLUMNS,
  [ModuleTypeEnum.EVENT]: EVENT_STANDARD_COLUMNS,
  [ModuleTypeEnum.SUPPLIER]: SUPPLIER_STANDARD_COLUMNS,
  [ModuleTypeEnum.MEMBER]: MEMBER_STANDARD_COLUMNS,
  [ModuleTypeEnum.EXPENSE]: EXPENSE_STANDARD_COLUMNS,
  [ModuleTypeEnum.TIME_ENTRY]: TIME_ENTRY_STANDARD_COLUMNS,
  [ModuleTypeEnum.INVENTORY]: INVENTORY_ITEM_STANDARD_COLUMNS,
  [ModuleTypeEnum.DOCUMENT]: DOCUMENT_STANDARD_COLUMNS,
  [ModuleTypeEnum.CUSTOM_COLLECTION]: CUSTOM_COLLECTION_ENTRY_STANDARD_COLUMNS,
  [ModuleTypeEnum.DEPLOYMENT]: DEPLOYMENT_STANDARD_COLUMNS,
}

export function getStandardColumnsForModule(
  moduleType: ModuleTypeEnum,
): ModuleColumnDefinition[] {
  return STANDARD_COLUMNS_BY_MODULE[moduleType] ?? []
}
